import { PrivateRouteDefinition } from "../components/core/model/PrivateRouteDefinition";
import { SupplyEfnScreen } from "../screens/SupplyEfnScreen";

export const SupplyEfnModuleRoutes: PrivateRouteDefinition[] = [
	{
		path: "/supply-efn",
		component: SupplyEfnScreen,
	},
];
